var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7917 11C18.7917 15.3033 15.3033 18.7917 11 18.7917C6.69682 18.7917 3.20837 15.3033 3.20837 11C3.20837 6.69682 6.69682 3.20837 11 3.20837C15.3033 3.20837 18.7917 6.69682 18.7917 11ZM20.1667 11C20.1667 16.0627 16.0627 20.1667 11 20.1667C5.93743 20.1667 1.83337 16.0627 1.83337 11C1.83337 5.93743 5.93743 1.83337 11 1.83337C16.0627 1.83337 20.1667 5.93743 20.1667 11ZM9.5268 15.4103L16.8889 8.04817L15.9166 7.0759L9.5268 13.4657L6.0838 10.0227L5.11153 10.995L9.5268 15.4103Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOutlined);
export default __webpack_public_path__ + "static/media/success-outlined.a76d701415d2a97c21d219b0b439b501.svg";
export { ForwardRef as ReactComponent };